var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routelist && _vm.routelist.length > 1)?_c('div',{staticClass:"topnav"},[_c('div',{staticClass:"menu"},_vm._l((_vm.routelist),function(item){return (item.right)?_c('router-link',{key:item.route,staticClass:"link",attrs:{"to":{ name: item.route }}},[_vm._v(_vm._s(item.name)+"\n        ")]):_vm._e()}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }